// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_DISMISS_SYNC_PLANS_WITH_PCO_MESSAGES,
} from './constants';

export function dismissSyncPlansWithPcoMessages() {
  return {
    type: HOME_DISMISS_SYNC_PLANS_WITH_PCO_MESSAGES,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_DISMISS_SYNC_PLANS_WITH_PCO_MESSAGES:
      return {
        ...state,
        syncPlansWithPcoMessages: ""
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/dismissSyncPlansWithPcoMessages.js